// web_components/wcScrollingBar/wcScrollingBar_Renderer.ts

/**
 * Generates the HTML for the wc-scrolling-bar component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
		<section id="${instanceId}" class="wc-scrolling-bar${variables.barBtnUrl && !variables.barBtnTarget ? ' active' : ''}" data-scroll-to="${variables.barBtnTarget}">
            <div>
            	${variables.barCopy ? `<span>${variables.barCopy}</span>` : ''}
            	${
					variables.barBtnUrl
						? `<a href = "${variables.barBtnUrl}">${variables.barBtnCopy}</a>`
						: `<button class = "wc-scrolling-bar__cta">${variables.barBtnCopy}</button>`
				}
            </div>
        </section>
    `;
}
